<template>
  <div>
    <v-card
      class="mx-auto"
      color="#546E7A"
      dark
      width="100%"
      height="420"
      elevation="2"
    >    
    <v-card-title >      
      <v-alert
        class="ml-2 d-flex justify-center"
        border="left"
        :color="custcardcolor"
        elevation="2"
        style="position:absolute; z-index:1;"
        width="90%"
        height="60"
      >
        <h4 class="font-weight-bold white--text">
          <small>{{ custname }}</small>
        </h4>          
      </v-alert>
    </v-card-title>
    <v-card-subtitle class="pt-1 text-right">
    <v-chip color="primary darken-1"  style="z-index:1;">Currency:{{ custCurrType }}</v-chip>
    </v-card-subtitle>
    <v-card-text>
      <div v-for="(progress, index) in progressItems" :key="index">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-progress-linear
                    class="mt-1 mb-2"
                    :color="progress.color"
                    height="6"
                    :value="progress.value"
                    stream
                  ></v-progress-linear>
                </div>
              </template>
              <span>{{ progress.label }}</span>
            </v-tooltip>
        </div>
     
      <!-- main content -->    
      <v-row dense justify="center" > 
        <v-col cols="4" class=" mt-5 d-flex justify-center" v-for="(item, index) in cardItems" :key="index">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div class="caption white--text font-weight-light">{{ item.label }}</div>
                <div class="subtitle-1 font-weight-bold white--text justify-center" v-html="item.value"></div>
              </div>
            </template>
            <span>{{ item.tooltip }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions >
      <v-row justify="center">
        <v-col cols="auto"  v-for="(action, index) in actions" :key="index">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab dark small color="primary" v-bind="attrs" v-on="on" @click="$emit(action.event)">
                <v-icon>{{ action.icon }}</v-icon>
              </v-btn>
            </template>
            <span>{{ action.tooltip }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-actions>
    </v-card>
    <v-progress-linear
      indeterminate
      color="primary"
      v-show="loading"
    ></v-progress-linear> 
  </div>
</template>

<script>


export default {
  name: "KPIcard",
  components: {},
  props: [
    "custname",
    "custblock",
    "custthismonthyield",
    "custthismonthsale",
    "custavgsale",
    "custouts",
    "custpdc",
    "custabv45",
    "custCrLimit",//alfa
    "custMstPDC",
    "custCurrType",
    "CustomerCode"
  ],
  data() {
    return {  
      actions: [
      { icon: 'mdi-contacts', event: 'showCustomerContacts', tooltip: 'Show Customer Contacts' },
      { icon: 'mdi-package', event: 'showCustomerProducts', tooltip: 'Show Customer Products' },
      { icon: 'mdi-file-document', event: 'showCustomerOutsDocs', tooltip: 'Show Customer Documents' },
      { icon: 'mdi-message-text', event: 'showCustomerJournals', tooltip: 'Show Customer Journals' },
      ],    
    };
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    cardItems() {
      return [
      { label: 'Yield', value: this.formatValue(this.custthismonthyield), tooltip: 'Profit this month' },
        { label: 'Sale', value: this.formatValue(this.custthismonthsale), tooltip: 'Sales this month' },
        { label: 'Avg. Sale', value: this.formatValue(this.custavgsale), tooltip: 'Average sale' },
        { label: 'Outstanding', value: this.formatValue(this.custouts), tooltip: 'Outstanding amount' },
        { label: 'PDC in hand', value: this.formatValue(this.custMstPDC), tooltip: 'Post-dated cheques in hand' },
        { label: 'Abv 45 days', value: this.formatValue(this.custabv45), tooltip: 'Outstanding above 45 days' },
        { label: 'Credit Limit', value: this.formatValue(this.custCrLimit), tooltip: 'Credit Limit' },
        { label: 'Avail. Credit', value: this.formatValue(this.availableCreditLimit), tooltip: 'Available Credit Limit' },
        { label: 'Yield % ', value: this.displaythisGP, tooltip: 'Gross Profit' },
      ];
    },
    custcardcolor() {
      return this.custblock == 1 ? "#E53935" : "#43A047";
    },
    progressItems() {
      return [
        {
          label: `GP: ${this.salepercent.toFixed(2)}% of average sale`,
          color: this.indicator,
          value: this.displaythisGP
        },
        {
          label: `Sales Progress: ${this.salepercent.toFixed(2)}% of average sale`,
          color: this.percentcolor,
          value: this.salepercent
        },
        {
          label: `Credit Usage: ${this.creditpercent.toFixed(2)}% of credit limit`,
          color: this.indicator,
          value: this.creditpercent
        },
      ];
    },
    displaythismonthyield() {
      if (this.custthismonthyield > 0) {
        return (
          // this.custCurrType +" "+
          this.custthismonthyield
            .toFixed(0)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",") 
        );
      } else {
        return 0.0;
        // this.custCurrType +" "+ 0.0;
      }
    },
    // //update form Alfa
    //  displaythisCreditLimit() {
    //   if (this.custCrLimit > 0) {
    //     return (
    //       // this.custCurrType +" "+
    //       this.custCrLimit
    //         .toFixed(0)
    //         .toString()
    //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //     );
    //   } else {
    //     return 0.0;
    //     // this.custCurrType +" "+ 0.0;
    //   }
    // },
     displaythisAvailableCreditLimit() {
      // if (this.custCrLimit > 0) {
        let totalReceivable =  this.custouts + this.custMstPDC
        let creditAvailable = this.custCrLimit - totalReceivable
        if (creditAvailable > 0) {
          return (
            // this.custCurrType +" "+
             creditAvailable
                .toFixed(0)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
             );
            //  }
      } else {
        return 0.0;
        // this.custCurrType +" "+ 0.0;
      }
    },
    displaythisGP() {
      return (this.custthismonthsale > 0 && this.custthismonthyield > 0)
        ? `${((this.custthismonthyield / this.custthismonthsale) * 100).toFixed(2)} %`
        : "0.0";
    },
    //end alfa
    // displaythismonthsale() {
    //   if (this.custthismonthsale > 0) {
    //     return (
    //       // this.custCurrType +" "+
    //       this.custthismonthsale
    //         .toFixed(0)
    //         .toString()
    //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //     );
    //   } else {
    //     return 0.0;
    //   }
    // },
    // displayavgsale() {
    //   if (this.custavgsale > 0) {
    //     return (
    //       // this.custCurrType +" "+
    //       this.custavgsale
    //         .toFixed(0)
    //         .toString()
    //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //     );
    //   } else {
    //     return 0.0;
    //     // this.custCurrType +" "+ 0.0;
    //   }
    // },
    // displayouts() {
    //   if (this.custouts > 0) {
    //     return (
    //       // this.custCurrType +" "+
    //       this.custouts
    //         .toFixed(0)
    //         .toString()
    //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //     );
    //   } else {
    //     return 0.0;
    //     // this.custCurrType +" "+ 0.0;
    //   }
    // },
    // displaypdc() {
    //   if (this.custMstPDC > 0) {
    //     return (
    //       // this.custCurrType +" "+
    //       this.custMstPDC
    //         .toFixed(0)
    //         .toString()
    //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //     );
    //   } else {
    //     return 0.0;
    //     // this.custCurrType +" "+ 0.0;
    //   }
    // },
    // displayabv45() {
    //   if (this.custabv45 > 0) {
    //     return (
    //       // this.custCurrType +" "+
    //       this.custabv45
    //         .toFixed(0)
    //         .toString()
    //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //     );
    //   } else {
    //     return 0.0;
    //     // this.custCurrType +" "+ 0.0;
    //   }
    // },
    salepercent() {
      return (this.custthismonthsale / this.custavgsale) * 100;
    },
    debtorRatio() {
      if (this.debtorratio) {
        return this.debtorratio.toFixed(2);
      } else {
        return 0;
      }
    },
    percentcolor() {
      if (this.salepercent >= 75) {
        return "teal accent-3";
      } else if (this.salepercent >= 50) {
        return "yellow accent-3";
      } else if (this.salepercent >= 25) {
        return "orange darken-1";
      } else {
        return "red";
      }
    },
    indicator() {
      let totalReceivable = this.custouts + this.custMstPDC;
      let creditAvailable = this.custCrLimit - totalReceivable;
      return creditAvailable < 0 ? "red" : "green";
    },
    creditpercent() {
      let totalReceivable = this.custouts + this.custMstPDC;
      let creditAvailable = this.custCrLimit - totalReceivable;
      return creditAvailable > this.custCrLimit
        ? (creditAvailable / this.custCrLimit) * 100
        : 0;
    },
    availableCreditLimit() {
      let totalReceivable = this.custouts + this.custMstPDC;
      return this.custCrLimit - totalReceivable;
    },
  },
  methods: {
    formatValue(value) {
      return value > 0
        ? value
            .toFixed(0)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : "0.0";
    },
    showContacts() {
      this.$emit("showCustomerContacts");
    },
    showProducts() {
      this.$emit("showCustomerProducts");
    },
    showOutsDocs() {
      this.$emit("showCustomerOutsDocs");
    },
    showJournals() {
      this.$emit("showCustomerJournals")
    },
  },
};
</script>
